"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.delete.tooltip': 'Delete conversation',
    'conversations.delete.confirm': 'Are you sure you want to delete "{title}"? This action cannot be undone.',
    'conversations.delete.success': 'Conversation deleted successfully',
    'conversations.delete.error': 'Failed to delete conversation',
    'conversations.delete.action': 'Delete',
};
